import React from "react";

const CashCardModal = ({
    show,
    onClose,
    input,
    setInput,
    getAmountDue,
    getReminingValue,
    handleClick,
    handleBackspace,
    handleSubmit
}) => {
    const amountDue = parseFloat(getAmountDue());
    const remainingValue = getReminingValue();
    const isDisabled = amountDue <= 0;

    const handleInputChange = (e) => {
        let value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) { // Allow only numbers & decimals
            if (setInput) {
                setInput(value);
            } else {
                // Fallback simulation if parent doesn't pass setInput
                if (value.length < input.length) {
                    handleBackspace();
                } else if (value.length > input.length) {
                    const diff = value.substring(input.length);
                    for (let char of diff) {
                        handleClick(char);
                    }
                }
            }
        }
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            style={{ display: show ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog">
                <div className="modal-content p-3">

                    {/* Modal Header */}
                    <div className="modal-header border-0">
                        <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body">
                        <div className="row">

                            {/* Number Pad Section - Commented out per request */}
                            {/* 
                            <div className="col-6">
                                <div className="phone-pad-container">
                                    <input
                                        type="text"
                                        value={input}
                                        readOnly
                                        className="phone-input"
                                        disabled={isDisabled}
                                    />
                                    <div className="grid-container">
                                        {["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "⌫"].map((key, index) => (
                                            <button
                                                key={index}
                                                className="key-btn"
                                                onClick={() => {
                                                    if (amountDue > 0) {
                                                        if (key === "⌫") {
                                                            handleBackspace();
                                                        } else {
                                                            const newValue = input + key;
                                                            if (parseFloat(newValue) <= amountDue || newValue === "-") {
                                                                handleClick(key);
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                {key}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            */}

                            {/* Payment Summary Section - Expanded to col-12 */}
                            <div className="col-12">
                                {[
                                    { label: "Total", value: amountDue },
                                    { label: "Cash", value: input },
                                    { label: "Card", value: remainingValue },
                                ].map(({ label, value }, index) => (
                                    <div key={index} className="mb-2">
                                        <label className="text-sm font-semibold text-gray-700 w-100">{label}</label>
                                        <input
                                            type="text"
                                            value={label === "Cash" ? value : Math.abs(value).toFixed(3)}
                                            disabled={label !== "Cash"}
                                            onChange={label === "Cash" ? handleInputChange : undefined}
                                            className={`w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none ${label == "Card" ? 'bg-warning-subtle' : ''}`}
                                        />
                                    </div>
                                ))}

                                {/* Pay Button */}
                                <button
                                    onClick={() => handleSubmit(5)}
                                    disabled={!input}
                                    className="w-full mt-2 btn btn-success text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition"
                                >
                                    Pay
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashCardModal;